export default "__VITE_ASSET__DmkCqm04__"